import {BatchedRenderer} from './BatchedRenderer';

export const BatchedParticleRenderer = BatchedRenderer;
